module.exports = __webpack_public_path__ + "static/quicksand-abecaf64895de9143f609ecdf95a4464.jpg";